export default __webpack_public_path__ + "static/media/image1.7a927555.png";